import { FaGraduationCap } from "react-icons/fa";
import magzineImage from "../../assets/img/resourcesImage.png";
import accountSearch from "../../assets/icons/account-search-icon.png";
import signals from "../../assets/icons/signal-icon.png";
import optimization from "../../assets/icons/optimization-icon.png";
import salesEngagement from "../../assets/icons/sales-plan-icon.png";
import meetingsIcon from "../../assets/icons/meetings-icon.png";
import dealManagement from "../../assets/icons/deal-management-icon.png";
import analyticsIcon from "../../assets/icons/analytics-icon.png";
import tropyIcon from "../../assets/icons/trophy-icon.png";
import workFlowIcon from "../../assets/icons/workflow-engine-icon.png";
import enrichCleaness from "../../assets/icons/cleanse-icon.png";
import recommendation from "../../assets/icons/conversation-icon.png";
import slaesLeader from "../../assets/icons/flag-icon.png";
import accountExecutive from "../../assets/icons/search.png";
import salesDevelopment from "../../assets/icons/sales-management.png";
import founders from "../../assets/icons/founders.png";
import marketers from "../../assets/icons/marketers.png";
import revenuOperation from "../../assets/icons/revenu.png";

export const leadbud = [
  {
    header: "Build Pipeline",
    links: [
      {
        link: "/account-search",
        img: accountSearch,
        heading: "Account Search",
        para: "Find the right leads & companies",
      },
      {
        link: "/scores-signals",
        img: signals,
        heading: "Scores & Signals",
        para: "Reach out to the right leads",
      },
      {
        link: "/",
        img: optimization,
        heading: "Inbound Optimization",
        para: "Shorten foms & better quality leads",
      },
      {
        link: "/",
        img: salesEngagement,
        heading: "Sales Engagement",
        para: "Automate your outbound",
      },
    ],
  },
  {
    header: "Close Deals",
    links: [
      {
        link: "/",
        img: meetingsIcon,
        heading: "Meetings",
        para: "Prepare for book & follow up on meetings",
      },
      {
        link: "/",
        img: dealManagement,
        heading: "Deal Management",
        para: "Close deals with insight & recomendations",
      },
      {
        link: "/",
        img: recommendation,
        heading: "Converstation Intelligence",
        para: "Track,record & analyze conversation",
      },
    ],
  },
  {
    header: "Performance",
    links: [
      {
        link: "/",
        img: analyticsIcon,
        heading: "Analytics",
        para: "See what's working and where to improve",
      },
      {
        link: "/",
        img: tropyIcon,
        heading: "Coaching",
        para: "Give your reps actionable feedback",
      },
    ],
  },
  {
    header: "Operation",
    links: [
      {
        link: "/",
        img: workFlowIcon,
        heading: "Workflow Engine",
        para: "Automate tasks & move faster on leads",
      },
      {
        link: "/",
        img: enrichCleaness,
        heading: "Enrich & Cleanse",
        para: "Automatically sync & enrich your CRM",
      },
    ],
  },

  {
    header: "Platforms",
    links: [
      {
        link: "/",
        heading: "Overview",
      },
      {
        link: "/",
        heading: "Living Data Network",
      },
      {
        link: "/",
        heading: "Integrations",
      },
    ],
  },
];

export const resources = [
  {
    header: "Latest from magazine",
    links: {
      image: magzineImage,
    },
  },
  {
    header: "Learn",
    links: [
      {
        link: "/",
        heading: "Apollo Magazines",
      },
      {
        link: "/",
        heading: "Academy",
      },
      {
        link: "/",
        heading: "Knowledge Base",
      },
      {
        link: "/",
        heading: "Webinars",
      },
      {
        link: "/",
        heading: "Events",
      },
      {
        link: "/",
        heading: "Careers",
      },
      {
        link: "/",
        heading: "Privacy Center",
      },
      {
        link: "/",
        heading: "Join the Community",
      },
    ],
  },
  {
    header: "Customers",
    links: [
      {
        link: "/",
        heading: "Success Stories",
      },
      {
        link: "/",
        heading: "Reviews",
      },
      {
        link: "/",
        heading: "Refer a friend",
      },
      {
        link: "/",
        heading: "Featured Customers",
      },
    ],
  },
  {
    header: "Partners",
    links: [
      {
        link: "/",
        heading: "Affiliate Partner",
      },
      {
        link: "/",
        heading: "Agency Partner",
      },
      {
        link: "/",
        heading: "Technology Partner ",
      },
      {
        link: "/",
        heading: "Startup Ecosystem Partner",
      },
      {
        link: "/",
        heading: "Certified Agency Directory",
      },
      {
        link: "/",
        heading: "Apollo Advocates",
      },
    ],
  },
];

export const solution = [
  {
    link: "/email-verifier",
    img: slaesLeader,
    mediaheading: "Email Verifier",
    para: "Ensure every email you send lands where it should.",
  },
  {
    link: "/email-finder",
    img: accountExecutive,
    mediaheading: "Email Finder",
    para: "Discover verified business emails in seconds.",
  },
  {
    link: "/b2b-prospecting-tool",
    img: salesDevelopment,
    mediaheading: "B2B Prospecting Tool",
    para: "Access a vast network of decision-makers and businesses.",
  },
  {
    link: "/facebook-tools",
    img: founders,
    mediaheading: "Founders",
    para: "Uncover hidden contact details from Facebook with ease.",
  },
  {
    link: "/meet-cara",
    img: marketers,
    mediaheading: "Meet Cara",
    para: "AI-powered lead generation through face recognition.",
  }
];

export const pages = [
  {
    link: "/blog",
    img: <FaGraduationCap className="text-[30px]" />,
    mediaheading: "Blog",
    para: "Expert Lead-crush courses on growing states.",
  },
  {
    link: "/pricing",
    img: <FaGraduationCap className="text-[30px]" />,
    mediaheading: "Pricing",
    para: "Expert Lead-crush courses on growing states.",
  },
  {
    link: "/affiliate-program",
    img: <FaGraduationCap className="text-[30px]" />,
    mediaheading: "Affiliate Program",
    para: "Expert Lead-crush courses on growing states.",
  },
  {
    link: "/contact-us",
    img: <FaGraduationCap className="text-[30px]" />,
    mediaheading: "Contact Us",
    para: "Expert Lead-crush courses on growing states.",
  },
  {
    link: "/privacy-policy",
    img: <FaGraduationCap className="text-[30px]" />,
    mediaheading: "Privacy policy",
    para: "Expert Lead-crush courses on growing states.",
  },
  {
    link: "/terms-condition",
    img: <FaGraduationCap className="text-[30px]" />,
    mediaheading: "Terms And Condition",
    para: "Expert Lead-crush courses on growing states.",
  },
  {
    link: "/landing-page",
    img: <FaGraduationCap className="text-[30px]" />,
    mediaheading: "Landing Page",
    para: "Expert Lead-crush courses on growing states.",
  },
];
